'use client'

import { Suspense } from 'react'
import ForgotPasswordPage from '@/domains/auth/pages/ForgotPasswordPage'

export default function ForgotPasswordRoutePage() {
  return (
    <Suspense fallback={null}>
      <ForgotPasswordPage />
    </Suspense>
  )
}
